//export const ROOT_URL = 'http://65.2.153.204:8080';
 export const ROOT_URL = 'https://libtest.jaipuriaschools.com'; 

 //export const ROOT_URL = 'http://localhost:8080';
export const API_PATH = ROOT_URL + '/api';

export const SUCCESSFULLY_DELETED = "Deleted successfully"
export const ERROR = "Error";

  export const IMAGE_BASE_URL = "https://libtest.jaipuriaschools.com";
